import styled from "styled-components";
import { Alert } from "antd";
import { SecondaryButtonComponent } from "../../commonStyles";

export const NoticeContainer = styled(Alert)`
  &.ant-alert.ant-alert-no-icon {
    border-radius: 0px;
    border: none;
    margin-bottom: 30px;
    padding: 20px 30px 20px 25px;
    border-left: 6px solid ${props => props.theme.colors.info};
    background-color: ${props =>
      props.theme.backgroundColor.cardDark}!important;
    @media only screen and (max-width: 767px) {
      flex-direction: column;
      border-top: 6px solid ${props => props.theme.colors.info};
      border-left: none;
      margin-bottom: 40px;
      padding: 15px 10px 20px 10px;
    }
  }
`;

export const NoticeContent = styled.div`
  @media only screen and (max-width: 767px) {
    flex-direction: column;
    justify-content: space-between !important;
  }
`;

export const FlexBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 767px) {
    display: block;
  }
`;

export const NoticeFooter = styled.div`
  margin-top: 10px;
`;

export const ButtonWrapper = styled.div`
  width: auto;
  font-size: ${props => props.theme.fontSize.secondary};
  align-self: flex-start;
  button > i {
    margin-top: 5px;
  }
  @media only screen and (max-width: 767px) {
    margin-top: 20px;
    button {
      width: auto;
    }
  }
`;

export const TextWrapper = styled.div`
  margin: 0 30px 0 0;
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: ${props => props.theme.lineHeight.primary};
  @media only screen and (max-width: 767px) {
    margin-right: 0px;
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const NoticeText = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  line-height: ${props => props.theme.lineHeight.primary};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (max-width: 767px) {
    line-height: ${props => props.theme.lineHeight.secondary};
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const NoticeHeading = styled.span`
  font-family: helveticaNeue;
  line-height: ${props => props.theme.lineHeight.primary};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.textColor};
  @media only screen and (max-width: 767px) {
    line-height: ${props => props.theme.lineHeight.secondary};
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const NoticeBlock = styled.div`
  opacity: ${props => (props.show ? "1" : "0")};
  height: ${props => (props.show ? "auto" : "0")};
  transition: opacity 0.25s ease, max-height 0.25s ease, font-size 0.25s ease;
  max-height: ${props => (props.show ? "999em" : "0")};
  font-size: ${props => (props.show ? props.theme.fontSize.primary : "0")};
  line-height: ${props => props.theme.lineHeight.primary};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.textColor};
  p {
    margin: 0;
  }
  @media only screen and (max-width: 767px) {
    font-size: ${props => (props.show ? props.theme.fontSize.secondary : "0")};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const SecondaryButtonWrapper = styled(SecondaryButtonComponent)`
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  font-size: ${props => props.theme.fontSize.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  > span {
    font-size: ${props => props.theme.fontSize.secondary};
    color: ${props => props.theme.fontColors.primary};
    padding: 0px 10px 0 0;
    font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
    font-style: normal;
    font-stretch: normal;
    line-height: ${props => props.theme.lineHeight.secondary};
    letter-spacing: ${props => props.theme.letterSpacing.zero};
  }
  @media only screen and (max-width: 767px) {
    width: 135px;
  }
`;
